import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormRecursionItem,
  title: 'Recursion Item',
  category: ComponentCategory.FormControls,
};
